"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendMessageBackToPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _sendMessageBack = require("../actions/sendMessageBack");

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(postActivityWithMessageBack),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(sendMessageBackToPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(sendMessageBackToPostActivitySaga);

// https://github.com/microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#message-back
function postActivityWithMessageBack(_ref) {
  var _ref$payload, displayText, text, value;

  return _regenerator["default"].wrap(function postActivityWithMessageBack$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref$payload = _ref.payload, displayText = _ref$payload.displayText, text = _ref$payload.text, value = _ref$payload.value;
          _context.next = 3;
          return (0, _effects.put)((0, _postActivity["default"])({
            channelData: {
              messageBack: {
                displayText: displayText
              }
            },
            text: text,
            type: 'message',
            value: value
          }));

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendMessageBackToPostActivity() {
  return _regenerator["default"].wrap(function sendMessageBackToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_sendMessageBack.SEND_MESSAGE_BACK, postActivityWithMessageBack);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function sendMessageBackToPostActivitySaga() {
  return _regenerator["default"].wrap(function sendMessageBackToPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(sendMessageBackToPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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